"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendMessageBackToPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _sendMessageBack = require("../actions/sendMessageBack");

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(postActivityWithMessageBack),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(sendMessageBackToPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(sendMessageBackToPostActivitySaga);

// https://github.com/microsoft/botframework-sdk/blob/main/specs/botframework-activity/botframework-activity.md#message-back
function postActivityWithMessageBack(_ref) {
  var _ref$payload, displayText, text, value;

  return _regenerator["default"].wrap(function postActivityWithMessageBack$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref$payload = _ref.payload, displayText = _ref$payload.displayText, text = _ref$payload.text, value = _ref$payload.value;
          _context.next = 3;
          return (0, _effects.put)((0, _postActivity["default"])({
            channelData: {
              messageBack: {
                displayText: displayText
              }
            },
            text: text,
            type: 'message',
            value: value
          }));

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendMessageBackToPostActivity() {
  return _regenerator["default"].wrap(function sendMessageBackToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_sendMessageBack.SEND_MESSAGE_BACK, postActivityWithMessageBack);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function sendMessageBackToPostActivitySaga() {
  return _regenerator["default"].wrap(function sendMessageBackToPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(sendMessageBackToPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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